import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { bemGenerator } from '@prisjakt/ui-base';
import ListItem from '@prisjakt/ui-list-item';

import './index.scss';

const styles = bemGenerator('related-resources-list', ['item']);

const SubCategoryList = ({ categories, collapse }) => (
  <div className={styles.block.withModifier({ collapse })}>
    {categories.map(category => (
      <ListItem
        key={category.id}
        name={category.name}
        link={category.pathName}
        showArrow
      />
    ))}
  </div>
);

SubCategoryList.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.object),
  collapse: PropTypes.bool,
};

SubCategoryList.defaultProps = {
  categories: [],
  collapse: false,
};

export default memo(SubCategoryList);
